
export default {
	name: "LetterLengthBoxLinks",
	props: {
		title: {
			required: true,
			type: String,
		},
		items: {
			required: true,
			type: Array,
		},
	},
	computed: {
		computedTitle() {
			return this.title;
		},
		computedItems() {
			return this.items || [];
		},
	},
};
